import { useEffect, useMemo, useState } from "react";
import { Check, Copy, Mail, X } from "lucide-react";
import { useLanguage } from "../i18n";
import { copy as siteCopy } from "../siteContent";
import "./ContactDialog.css";

const email = "jarmo@pk-forensics.fi";

export default function ContactDialog({ open, onClose }) {
  const { language } = useLanguage();
  const [copied, setCopied] = useState(false);
  const t = siteCopy[language].contactDialog;
  const links = useMemo(() => {
    const to = encodeURIComponent(email);
    const subject = encodeURIComponent(t.subject);
    return {
      gmail: `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}`,
      outlook: `https://outlook.office.com/mail/deeplink/compose?to=${to}&subject=${subject}`,
    };
  }, [t.subject]);

  useEffect(() => {
    if (!open) return undefined;
    setCopied(false);
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  const copyEmail = async () => {
    await navigator.clipboard.writeText(email);
    setCopied(true);
  };

  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="contact-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-dialog-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button className="dialog-close" type="button" onClick={onClose} aria-label={t.close}>
          <X size={22} />
        </button>
        <p className="section-label">{t.label}</p>
        <h2 id="contact-dialog-title">{t.title}</h2>
        <p className="contact-dialog-intro">{t.body}</p>
        <div className="contact-email"><Mail size={20} /><span>{email}</span></div>
        <div className="contact-dialog-actions">
          <a className="button button-accent" href={links.gmail} target="_blank" rel="noreferrer">{t.gmail}</a>
          <a className="button button-dark" href={links.outlook} target="_blank" rel="noreferrer">{t.outlook}</a>
        </div>
        <button className="copy-email-button" type="button" onClick={copyEmail}>
          {copied ? <Check size={17} /> : <Copy size={17} />}
          {copied ? t.copied : t.copy}
        </button>
      </section>
    </div>
  );
}
